/** Constants */
export const ORGANIZATION_INVITE_QUERY_PARAM = 'organizationInvite';
export const MEMBER_ORGANIZATION_INVITE_EXPIRATION_DAYS = 30;
export const EXTERNAL_ORGANIZATION_INVITE_EXPIRATION_DAYS = 7;


/** Functions */
export function addDays(date: Date, days: number) {
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + days);
    return nextDate;
}

export function isExpired(expiresAt: Date, now = new Date()) {
    return expiresAt.getTime() <= now.getTime();
}
